import React, { useState } from 'react'
import { Document, Page } from 'react-pdf'
import pdfGuide from '../../pdf/userGuide.pdf'

function UserGuide () {
  const [numPages, setNumPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(1)

  function onDocumentLoadSuccess ({ numPages }) {
    setNumPages(numPages)
  }

  return (
    <div>
      <Document file={pdfGuide} onLoadSuccess={onDocumentLoadSuccess}>
        <Page pageNumber={pageNumber} />
      </Document>
      <p>
        Page {pageNumber} of {numPages}
      </p>
    </div>
  )
}

export default UserGuide
